export class CognitoUser {
  public id?: string;
  public username?: string;
  public name?: string;
  public familyName?: string;
  public preferredName?: string;
  public email?: string;
  public phoneNumber?: string;
  public avatarUrl?: string;
  // public whatsappNotification?: boolean;
  // public emailNotification?: boolean;

  constructor(
    id?: string,
    username?: string,
    name?: string,
    familyName?: string,
    preferredName?: string,
    email?: string,
    phoneNumber?: string,
    avatarUrl?: string,
    // whatsappNotification?: boolean,
    // emailNotification?: boolean
  ) {
    this.id = id ? id : null;
    this.username = username ? username : null;
    this.name = name ? name : null;
    this.familyName = familyName ? familyName : null;
    this.preferredName = preferredName ? preferredName : '';
    this.email = email ? email : null;
    this.phoneNumber = phoneNumber ? phoneNumber : null;
    this.avatarUrl = avatarUrl ? avatarUrl : '';
    // this.whatsappNotification = whatsappNotification
    //   ? whatsappNotification
    //   : false;
    // this.emailNotification = emailNotification ? emailNotification : false;
  }

  fromAWS(attr: any) {
    return new CognitoUser(
      attr.sub,
      '',
      attr.name,
      attr.family_name,
      attr.name,
      attr.email,
      attr.phone_number,
      attr.picture,
      // attr['custom:whatsappNotification'] == 1,
      // attr['custom:emailNotification'] == 1
    );
  }

  toAWS() {
    return {
      name: this.name,
      family_name: this.familyName,
      email: this.email,
      preferred_username: this.preferredName,
      phone_number: this.phoneNumber,
      picture: this.avatarUrl,
      // 'custom:whatsappNotification': this.whatsappNotification ? '1' : '0',
      // 'custom:emailNotification': this.emailNotification ? '1' : '0'
    };
  }
}
